export default __webpack_public_path__ + "static/media/thirdPage.17c4e166.png";